module.exports = __webpack_public_path__ + "static/media/real1.ed93b595.jpg";